export default __webpack_public_path__ + "img/tremors/tremors4_1500.jpg";